import {
  CookieCategory,
  CookieSerializeOptions,
} from '@moonpig/web-core-browser-storage'

const secondsInAnHour = 60 * 60

export const userIsFromAd = (
  getCookie: (name: string) => string | undefined,
  setCookie: (
    name: string,
    value: string,
    options: CookieSerializeOptions,
    category: CookieCategory,
  ) => void,
  utmMediumQueryParam: string | undefined,
) => {
  if (getCookie('mnpg_user_is_from_ad') === 'true') return true
  if (utmMediumQueryParam === 'cpc') {
    setCookie(
      'mnpg_user_is_from_ad',
      'true',
      {
        maxAge: secondsInAnHour,
        path: '/',
      },
      CookieCategory.STRICTLY_NECESSARY,
    )
    return true
  }
  return false
}
